export const LOTTERY_LAYOUT = {
  breadcrumbLast: 'Sorteo',
  breadcrumbMb: 2,
  contentPt: 1,
  contentPb: 2,
  legalInsideCard: true,
  cardWidth: '100%',
};

const SHOW_GIT_REGISTRATION_BY_SITE = {
  git: true,
};

export const showGitRegistrationForSite = site =>
  Boolean(SHOW_GIT_REGISTRATION_BY_SITE[site]);
